import { Children, useEffect, useRef, useState, type ReactNode } from 'react';

export default function TestimonialCarousel({ children }: { children: ReactNode }) {
  const track = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const count = Children.count(children);
  const goTo = (index: number) => {
    const element = track.current;
    if (!element) return;
    const slide = element.children[index] as HTMLElement;
    element.scrollTo({ left: slide.offsetLeft - (element.children[0] as HTMLElement).offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
  useEffect(() => {
    if (paused) return;
    const timer = window.setInterval(() => {
      const element = track.current;
      if (!element || document.hidden || !window.matchMedia('(max-width: 767px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const bounds = element.getBoundingClientRect();
      if (bounds.top < 0 || bounds.bottom > window.innerHeight) return;
      goTo((active + 1) % count);
    }, 5000);
    return () => window.clearInterval(timer);
  }, [active, count, paused]);
  return <div className="mt-9 lg:mt-12">
    <div ref={track} className="nomsy-quotes grid gap-4 md:grid-cols-12 lg:gap-5"
      onTouchStart={() => setPaused(true)} onFocusCapture={() => setPaused(true)}
      onScroll={() => {
        const element = track.current;
        if (!element) return;
        const step = (element.children[0] as HTMLElement).offsetWidth + 16;
        setActive(Math.max(0, Math.min(count - 1, Math.round(element.scrollLeft / step))));
      }}>
      {children}
    </div>
    <div className="nomsy-quote-controls" role="group" aria-label="Quote carousel controls">
      {Array.from({ length: count }, (_, index) => <button key={index} type="button" aria-label={`Show quote ${index + 1}`} aria-pressed={active === index} onClick={() => { setPaused(true); goTo(index); }}><span /></button>)}
      <button type="button" className="nomsy-quote-pause" onClick={() => setPaused(!paused)}>{paused ? 'Play' : 'Pause'}</button>
    </div>
  </div>;
}
